var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".social-cls1{fill:#231f20;}")),React.createElement("path",{"className":"social-cls1","d":"M16.32,1.1A15.06,15.06,0,1,0,31.38,16.16,15.06,15.06,0,0,0,16.32,1.1Zm0,29.12A14.06,14.06,0,1,1,30.38,16.16,14.05,14.05,0,0,1,16.32,30.22ZM15.26,8.74a3.85,3.85,0,0,0-1,2.86v2.33H11.73v2.94h2.49v7.4h3v-7.4h2.36L20,13.93H17.26v-2a1.69,1.69,0,0,1,.26-1,1.48,1.48,0,0,1,1.19-.39h1.56V7.86A15.6,15.6,0,0,0,18,7.73,3.76,3.76,0,0,0,15.26,8.74Z","transform":"translate(-1.26 -1.1)","key":1})]);
}

SocialFacebook.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 30.12 30.12"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
